export const ACTING_IDLE_MS = 10 * 60 * 1000;

export const STATION_PRINT_SETTINGS_PATH = '/settings/printing';

export function isStationUser(user) {
  const flag = user?.is_station;
  return flag === true || flag === 1 || flag === '1';
}

export function stationHasPrintSettings(user) {
  return isStationUser(user) && user?.permissions?.printQueue === true;
}

export function stationRouteAllowed(pathname, user) {
  const path = String(pathname || '').split('?')[0];
  if (path === '/production/next' || path.startsWith('/production/next/')) return true;
  if (!stationHasPrintSettings(user)) return false;
  return path === STATION_PRINT_SETTINGS_PATH || path.startsWith(`${STATION_PRINT_SETTINGS_PATH}/`);
}

export function isActingExpired(lastActivityAt, now = Date.now(), timeoutMs = ACTING_IDLE_MS) {
  if (lastActivityAt == null) return true;
  return (now - Number(lastActivityAt)) >= timeoutMs;
}

export function employeeDisplayName(employee) {
  if (!employee) return '';
  const named = String(employee.name || '').trim();
  if (named) return named;
  return `${employee.lastName || ''} ${employee.firstName || ''}`.trim();
}

export function shouldBlockProduce(isStation, acting) {
  return Boolean(isStation) && !acting;
}
